import React from 'react';
import * as R from 'ramda';

import colors from '@atom/styles/colors';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

import { schema } from './collinsMpcConstants';
import {
  getAttributeDataRows,
  getNestedElementDisplayRows,
} from './collinsMpcUtilities';

import './collinsMpcPdfReport.css';

interface Props {
  element: any;
  mediaDictionary: any;
}

const NestedElement = ({ element, mediaDictionary }: Props) => {
  const attributes = getAttributeDataRows(
    element?.attributes,
    R.pathOr([], ['attributeGroups', 0, 'attributes'], element),
  );
  const filteredAttributes = attributes.filter(
    attribute => attribute.id !== schema.poolAttributes.description,
  );

  const media = mediaDictionary[element?.id];

  const descriptionText = R.pathOr(
    null,
    ['attributes', schema.poolAttributes.description, 'value'],
    element,
  );

  const displayRows = getNestedElementDisplayRows(filteredAttributes, media);

  return (
    <div styleName="section-box">
      <div styleName="section-title">{element?.name}</div>
      {descriptionText && (
        <div styleName="element-description">
          <div styleName="description-title">Description:</div>
          <div>{descriptionText}</div>
        </div>
      )}
      {displayRows.map(item => {
        return (
          <div styleName="element-row">
            {item.map((displayItem, index) => {
              const style = {
                borderRight:
                  index === 0 ? `2px solid ${colors.neutral.silver}` : 'none',
              };

              const photoStyle = {
                backgroundImage: `url('${FILES_ENDPOINT}/${displayItem?.fileId}_360')`,
              };

              return displayItem.isMedia ? (
                <div style={style} styleName="photo-box">
                  <div styleName="photo" style={photoStyle} />
                </div>
              ) : (
                <div style={style} styleName="element-display-box">
                  {displayItem?.attributes.map(attribute => {
                    return (
                      <div styleName="data-row" key={attribute?.id}>
                        <div styleName="data-title">{`${attribute?.name}:`}</div>
                        <div styleName="data-content">
                          {attributeDisplayUtility.display(
                            attribute.value,
                            attribute.dataType,
                            attribute.unit,
                            !!attribute.changeId,
                            attribute.newValue,
                            attribute.thousandsSeparator,
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default NestedElement;
